import { render, staticRenderFns } from "./Nueva.vue?vue&type=template&id=19127a65"
import script from "./Nueva.vue?vue&type=script&lang=js"
export * from "./Nueva.vue?vue&type=script&lang=js"
import style0 from "./Nueva.vue?vue&type=style&index=0&id=19127a65&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports